import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Checkbox from "@material-ui/core/Checkbox";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
}));

const GoLongShort = ({top,dispatchTop, usedSymbols}) => {
  const classes = useStyles();
  //let top = props.top;
  //let dispatchTop = props.dispatchTop;
  let isAlreadyLong = top.goLong;
  let isAlreadyShort = top.goShort;
  let [symbolsUsed, setSymbolsUsed] = usedSymbols;

  return (
    <div>
      <FormControl component="fieldset">
        <FormGroup row>
          <FormLabel>
            {<Typography style={{ fontSize: 12 }}>Direction: </Typography>}
          </FormLabel>
          <FormControlLabel
            control={
              <Checkbox
                checked={isAlreadyLong}
                onChange={(ev) => {
                  dispatchTop({ goLong: ev.target.checked });
                }}
                name="goLong"
              />
            }
            label={<Typography style={{ fontSize: 12 }}>Long</Typography>}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={isAlreadyShort}
                onChange={(ev) => {
                  dispatchTop({ goShort: ev.target.checked });
                }}
                name="goShort"
              />
            }
            label={<Typography style={{ fontSize: 12 }}>Short</Typography>}
          />
        </FormGroup>
      </FormControl>
    </div>
  );
};

export default GoLongShort;
